export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";